module.exports = __webpack_public_path__ + "fa52f83b4afcec8bf294bba32e8342e5.jpg";